<template>
    <div class="header">
        <el-tabs
            v-model="editableTabsValue"
            type="card"
            class="demo-tabs"
            @tab-remove="removeTab"
            @tab-click="changeTab"
        >
            <el-tab-pane name="首页">
                <template #label>
                    <span class="custom-tabs-label">
                      <i class="icon-ico_sy"></i>
                      <span>首页</span>
                    </span>
                </template>
            </el-tab-pane>
            <el-tab-pane
                v-for="item in editableTabs"
                :key="item.label"
                :label="item.label"
                :name="item.label"
                closable
            >
            </el-tab-pane>
        </el-tabs>
        <div class="header_right">
            <!--            <div class="headerTabNum">-->
            <!--                <el-dropdown>-->
            <!--                    <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">-->
            <!--                        <path-->
            <!--                            d="M19.3323 4.8889C19.3323 4.64344 19.5313 4.44446 19.7768 4.44446V4.44446C20.0222 4.44446 20.2212 4.64344 20.2212 4.8889V15.5556C20.2212 15.801 20.0222 16 19.7768 16V16C19.5313 16 19.3323 15.801 19.3323 15.5556V4.8889Z"-->
            <!--                            fill="#253858"/>-->
            <!--                        <path-->
            <!--                            d="M21.1101 7.55556C21.1101 7.3101 21.3091 7.11111 21.5546 7.11111V7.11111C21.8 7.11111 21.999 7.3101 21.999 7.55556V15.5556C21.999 15.801 21.8 16 21.5546 16V16C21.3091 16 21.1101 15.801 21.1101 15.5556V7.55556Z"-->
            <!--                            fill="#253858"/>-->
            <!--                        <rect x="1.16571" y="0.5" width="16.7778" height="15" rx="1.5" stroke="#253858"/>-->
            <!--                    </svg>-->
            <!--                    <span>{{editableTabs.length+1}}</span>-->
            <!--                    <template #dropdown>-->
            <!--                        <div class="headerTabNum_dropDow">-->
            <!--                            <div class="headerTabNum_item">-->
            <!--                                <div class="headerTabNum_item_home">-->
            <!--                                    <div class="headerTabNum_item_title" @click="changeTabSelect('首页')">-->
            <!--                                        <i class="icon-ico_sy"></i>首页-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                                <div class="headerTabNum_item_list" v-for="(item,index) in editableTabs" @click="changeTabSelect(item.label)">-->
            <!--                                    <p>{{item.label}}</p>-->
            <!--                                    <svg @click.stop="removeTab(item.label)" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-ba633cb8=""><path fill="currentColor" d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"></path></svg>-->
            <!--                                </div>-->
            <!--                            </div>-->
            <!--                        </div>-->
            <!--                    </template>-->
            <!--                </el-dropdown>-->
            <!--            </div>-->
            <!--            <div class="headerLine">-->

            <!--            </div>-->
            <!--            <div class="headerVector">-->
            <!--                <i class="icon-ico_qjt"></i>-->
            <!--            </div>-->
            <!--            <div class="headerUnion">-->
            <!--                <el-badge :value="90" class="item">-->
            <!--                    <i class="icon-Union"></i>-->
            <!--                </el-badge>-->
            <!--            </div>-->
            <!--            <div class="headerTxl">-->
            <!--                &lt;!&ndash;<i class="icon-ico_txl"></i>&ndash;&gt;-->
            <!--                <el-dropdown>-->
            <!--                    <i class="icon-ico_txl"></i>-->
            <!--                    <template #dropdown>-->
            <!--                        <div class="header_txl">-->
            <!--                            <div class="header_txl_phone">-->
            <!--                                <i class="icon-phone"></i>-->
            <!--                            </div>-->
            <!--                            <div class="header_txl_title">-->
            <!--                                <p>通讯录</p>-->
            <!--                                <div class="header_txl_search">-->
            <!--                                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-ba633cb8="">-->
            <!--                                        <path fill="currentColor"-->
            <!--                                              d="m795.904 750.72 124.992 124.928a32 32 0 0 1-45.248 45.248L750.656 795.904a416 416 0 1 1 45.248-45.248zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704z"></path>-->
            <!--                                    </svg>-->
            <!--                                    <input type="text" placeholder="请输入部门/姓名/手机">-->
            <!--                                </div>-->
            <!--                            </div>-->
            <!--                            <div class="header_txl_list">-->
            <!--                                <div class="header_txl_item">-->
            <!--                                    <div class="header_txl_item_capital">-->
            <!--                                        B-->
            <!--                                    </div>-->
            <!--                                    <div class="header_txl_item_con">-->
            <!--                                        <div class="header_tic_left ellipsis" title="北京亦庄国际亦庄国际">-->
            <!--                                            北京亦庄国际亦庄国际-->
            <!--                                        </div>-->
            <!--                                        <div class="header_tic_right">-->
            <!--                                            <div class="header_ticr_list">-->
            <!--                                                <div class="header_ticr_list_leader">-->
            <!--                                                    部门领导-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_name">-->
            <!--                                                    王蓦瑶-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_fixedPhone">-->
            <!--                                                    89028586-->
            <!--                                                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"-->
            <!--                                                         data-v-ba633cb8="">-->
            <!--                                                        <path fill="currentColor"-->
            <!--                                                              d="M128 320v576h576V320H128zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zM960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32zM256 672h320v64H256v-64zm0-192h320v64H256v-64z"></path>-->
            <!--                                                    </svg>-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_mobile">-->
            <!--                                                    17835523140-->
            <!--                                                </div>-->
            <!--                                            </div>-->
            <!--                                            <div class="header_ticr_list">-->
            <!--                                                <div class="header_ticr_list_leader">-->
            <!--                                                    部门领导-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_name">-->
            <!--                                                    王蓦瑶-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_fixedPhone">-->
            <!--                                                    89028586-->
            <!--                                                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"-->
            <!--                                                         data-v-ba633cb8="">-->
            <!--                                                        <path fill="currentColor"-->
            <!--                                                              d="M128 320v576h576V320H128zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zM960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32zM256 672h320v64H256v-64zm0-192h320v64H256v-64z"></path>-->
            <!--                                                    </svg>-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_mobile">-->
            <!--                                                    17835523140-->
            <!--                                                </div>-->
            <!--                                            </div>-->

            <!--                                        </div>-->
            <!--                                    </div>-->
            <!--                                    <div class="header_txl_item_con">-->
            <!--                                        <div class="header_tic_left ellipsis" title="北京亦庄国际亦庄国际">-->
            <!--                                            北京亦庄国际亦庄国际-->
            <!--                                        </div>-->
            <!--                                        <div class="header_tic_right">-->
            <!--                                            <div class="header_ticr_list">-->
            <!--                                                <div class="header_ticr_list_leader">-->
            <!--                                                    部门领导-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_name">-->
            <!--                                                    王蓦瑶-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_fixedPhone">-->
            <!--                                                    89028586-->
            <!--                                                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"-->
            <!--                                                         data-v-ba633cb8="">-->
            <!--                                                        <path fill="currentColor"-->
            <!--                                                              d="M128 320v576h576V320H128zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zM960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32zM256 672h320v64H256v-64zm0-192h320v64H256v-64z"></path>-->
            <!--                                                    </svg>-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_mobile">-->
            <!--                                                    17835523140-->
            <!--                                                </div>-->
            <!--                                            </div>-->
            <!--                                            <div class="header_ticr_list">-->
            <!--                                                <div class="header_ticr_list_leader">-->
            <!--                                                    部门领导-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_name">-->
            <!--                                                    王蓦瑶-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_fixedPhone">-->
            <!--                                                    89028586-->
            <!--                                                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"-->
            <!--                                                         data-v-ba633cb8="">-->
            <!--                                                        <path fill="currentColor"-->
            <!--                                                              d="M128 320v576h576V320H128zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zM960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32zM256 672h320v64H256v-64zm0-192h320v64H256v-64z"></path>-->
            <!--                                                    </svg>-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_mobile">-->
            <!--                                                    17835523140-->
            <!--                                                </div>-->
            <!--                                            </div>-->

            <!--                                        </div>-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                                <div class="header_txl_item">-->
            <!--                                    <div class="header_txl_item_capital">-->
            <!--                                        B-->
            <!--                                    </div>-->
            <!--                                    <div class="header_txl_item_con">-->
            <!--                                        <div class="header_tic_left ellipsis" title="北京亦庄国际亦庄国际">-->
            <!--                                            北京亦庄国际亦庄国际-->
            <!--                                        </div>-->
            <!--                                        <div class="header_tic_right">-->
            <!--                                            <div class="header_ticr_list">-->
            <!--                                                <div class="header_ticr_list_leader">-->
            <!--                                                    部门领导-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_name">-->
            <!--                                                    王蓦瑶-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_fixedPhone">-->
            <!--                                                    89028586-->
            <!--                                                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"-->
            <!--                                                         data-v-ba633cb8="">-->
            <!--                                                        <path fill="currentColor"-->
            <!--                                                              d="M128 320v576h576V320H128zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zM960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32zM256 672h320v64H256v-64zm0-192h320v64H256v-64z"></path>-->
            <!--                                                    </svg>-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_mobile">-->
            <!--                                                    17835523140-->
            <!--                                                </div>-->
            <!--                                            </div>-->
            <!--                                            <div class="header_ticr_list">-->
            <!--                                                <div class="header_ticr_list_leader">-->
            <!--                                                    部门领导-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_name">-->
            <!--                                                    王蓦瑶-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_fixedPhone">-->
            <!--                                                    89028586-->
            <!--                                                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"-->
            <!--                                                         data-v-ba633cb8="">-->
            <!--                                                        <path fill="currentColor"-->
            <!--                                                              d="M128 320v576h576V320H128zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zM960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32zM256 672h320v64H256v-64zm0-192h320v64H256v-64z"></path>-->
            <!--                                                    </svg>-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_mobile">-->
            <!--                                                    17835523140-->
            <!--                                                </div>-->
            <!--                                            </div>-->

            <!--                                        </div>-->
            <!--                                    </div>-->
            <!--                                    <div class="header_txl_item_con">-->
            <!--                                        <div class="header_tic_left ellipsis" title="北京亦庄国际亦庄国际">-->
            <!--                                            北京亦庄国际亦庄国际-->
            <!--                                        </div>-->
            <!--                                        <div class="header_tic_right">-->
            <!--                                            <div class="header_ticr_list">-->
            <!--                                                <div class="header_ticr_list_leader">-->
            <!--                                                    部门领导-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_name">-->
            <!--                                                    王蓦瑶-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_fixedPhone">-->
            <!--                                                    89028586-->
            <!--                                                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"-->
            <!--                                                         data-v-ba633cb8="">-->
            <!--                                                        <path fill="currentColor"-->
            <!--                                                              d="M128 320v576h576V320H128zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zM960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32zM256 672h320v64H256v-64zm0-192h320v64H256v-64z"></path>-->
            <!--                                                    </svg>-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_mobile">-->
            <!--                                                    17835523140-->
            <!--                                                </div>-->
            <!--                                            </div>-->
            <!--                                            <div class="header_ticr_list">-->
            <!--                                                <div class="header_ticr_list_leader">-->
            <!--                                                    部门领导-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_name">-->
            <!--                                                    王蓦瑶-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_fixedPhone">-->
            <!--                                                    89028586-->
            <!--                                                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"-->
            <!--                                                         data-v-ba633cb8="">-->
            <!--                                                        <path fill="currentColor"-->
            <!--                                                              d="M128 320v576h576V320H128zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zM960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32zM256 672h320v64H256v-64zm0-192h320v64H256v-64z"></path>-->
            <!--                                                    </svg>-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_mobile">-->
            <!--                                                    17835523140-->
            <!--                                                </div>-->
            <!--                                            </div>-->

            <!--                                        </div>-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                                <div class="header_txl_item">-->
            <!--                                    <div class="header_txl_item_capital">-->
            <!--                                        B-->
            <!--                                    </div>-->
            <!--                                    <div class="header_txl_item_con">-->
            <!--                                        <div class="header_tic_left ellipsis" title="北京亦庄国际亦庄国际">-->
            <!--                                            北京亦庄国际亦庄国际-->
            <!--                                        </div>-->
            <!--                                        <div class="header_tic_right">-->
            <!--                                            <div class="header_ticr_list">-->
            <!--                                                <div class="header_ticr_list_leader">-->
            <!--                                                    部门领导-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_name">-->
            <!--                                                    王蓦瑶-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_fixedPhone">-->
            <!--                                                    89028586-->
            <!--                                                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"-->
            <!--                                                         data-v-ba633cb8="">-->
            <!--                                                        <path fill="currentColor"-->
            <!--                                                              d="M128 320v576h576V320H128zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zM960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32zM256 672h320v64H256v-64zm0-192h320v64H256v-64z"></path>-->
            <!--                                                    </svg>-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_mobile">-->
            <!--                                                    17835523140-->
            <!--                                                </div>-->
            <!--                                            </div>-->
            <!--                                            <div class="header_ticr_list">-->
            <!--                                                <div class="header_ticr_list_leader">-->
            <!--                                                    部门领导-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_name">-->
            <!--                                                    王蓦瑶-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_fixedPhone">-->
            <!--                                                    89028586-->
            <!--                                                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"-->
            <!--                                                         data-v-ba633cb8="">-->
            <!--                                                        <path fill="currentColor"-->
            <!--                                                              d="M128 320v576h576V320H128zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zM960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32zM256 672h320v64H256v-64zm0-192h320v64H256v-64z"></path>-->
            <!--                                                    </svg>-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_mobile">-->
            <!--                                                    17835523140-->
            <!--                                                </div>-->
            <!--                                            </div>-->

            <!--                                        </div>-->
            <!--                                    </div>-->
            <!--                                    <div class="header_txl_item_con">-->
            <!--                                        <div class="header_tic_left ellipsis" title="北京亦庄国际亦庄国际">-->
            <!--                                            北京亦庄国际亦庄国际-->
            <!--                                        </div>-->
            <!--                                        <div class="header_tic_right">-->
            <!--                                            <div class="header_ticr_list">-->
            <!--                                                <div class="header_ticr_list_leader">-->
            <!--                                                    部门领导-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_name">-->
            <!--                                                    王蓦瑶-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_fixedPhone">-->
            <!--                                                    89028586-->
            <!--                                                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"-->
            <!--                                                         data-v-ba633cb8="">-->
            <!--                                                        <path fill="currentColor"-->
            <!--                                                              d="M128 320v576h576V320H128zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zM960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32zM256 672h320v64H256v-64zm0-192h320v64H256v-64z"></path>-->
            <!--                                                    </svg>-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_mobile">-->
            <!--                                                    17835523140-->
            <!--                                                </div>-->
            <!--                                            </div>-->
            <!--                                            <div class="header_ticr_list">-->
            <!--                                                <div class="header_ticr_list_leader">-->
            <!--                                                    部门领导-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_name">-->
            <!--                                                    王蓦瑶-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_fixedPhone">-->
            <!--                                                    89028586-->
            <!--                                                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"-->
            <!--                                                         data-v-ba633cb8="">-->
            <!--                                                        <path fill="currentColor"-->
            <!--                                                              d="M128 320v576h576V320H128zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zM960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32zM256 672h320v64H256v-64zm0-192h320v64H256v-64z"></path>-->
            <!--                                                    </svg>-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_mobile">-->
            <!--                                                    17835523140-->
            <!--                                                </div>-->
            <!--                                            </div>-->

            <!--                                        </div>-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                                <div class="header_txl_item">-->
            <!--                                    <div class="header_txl_item_capital">-->
            <!--                                        B-->
            <!--                                    </div>-->
            <!--                                    <div class="header_txl_item_con">-->
            <!--                                        <div class="header_tic_left ellipsis" title="北京亦庄国际亦庄国际">-->
            <!--                                            北京亦庄国际亦庄国际-->
            <!--                                        </div>-->
            <!--                                        <div class="header_tic_right">-->
            <!--                                            <div class="header_ticr_list">-->
            <!--                                                <div class="header_ticr_list_leader">-->
            <!--                                                    部门领导-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_name">-->
            <!--                                                    王蓦瑶-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_fixedPhone">-->
            <!--                                                    89028586-->
            <!--                                                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"-->
            <!--                                                         data-v-ba633cb8="">-->
            <!--                                                        <path fill="currentColor"-->
            <!--                                                              d="M128 320v576h576V320H128zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zM960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32zM256 672h320v64H256v-64zm0-192h320v64H256v-64z"></path>-->
            <!--                                                    </svg>-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_mobile">-->
            <!--                                                    17835523140-->
            <!--                                                </div>-->
            <!--                                            </div>-->
            <!--                                            <div class="header_ticr_list">-->
            <!--                                                <div class="header_ticr_list_leader">-->
            <!--                                                    部门领导-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_name">-->
            <!--                                                    王蓦瑶-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_fixedPhone">-->
            <!--                                                    89028586-->
            <!--                                                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"-->
            <!--                                                         data-v-ba633cb8="">-->
            <!--                                                        <path fill="currentColor"-->
            <!--                                                              d="M128 320v576h576V320H128zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zM960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32zM256 672h320v64H256v-64zm0-192h320v64H256v-64z"></path>-->
            <!--                                                    </svg>-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_mobile">-->
            <!--                                                    17835523140-->
            <!--                                                </div>-->
            <!--                                            </div>-->

            <!--                                        </div>-->
            <!--                                    </div>-->
            <!--                                    <div class="header_txl_item_con">-->
            <!--                                        <div class="header_tic_left ellipsis" title="北京亦庄国际亦庄国际">-->
            <!--                                            北京亦庄国际亦庄国际-->
            <!--                                        </div>-->
            <!--                                        <div class="header_tic_right">-->
            <!--                                            <div class="header_ticr_list">-->
            <!--                                                <div class="header_ticr_list_leader">-->
            <!--                                                    部门领导-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_name">-->
            <!--                                                    王蓦瑶-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_fixedPhone">-->
            <!--                                                    89028586-->
            <!--                                                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"-->
            <!--                                                         data-v-ba633cb8="">-->
            <!--                                                        <path fill="currentColor"-->
            <!--                                                              d="M128 320v576h576V320H128zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zM960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32zM256 672h320v64H256v-64zm0-192h320v64H256v-64z"></path>-->
            <!--                                                    </svg>-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_mobile">-->
            <!--                                                    17835523140-->
            <!--                                                </div>-->
            <!--                                            </div>-->
            <!--                                            <div class="header_ticr_list">-->
            <!--                                                <div class="header_ticr_list_leader">-->
            <!--                                                    部门领导-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_name">-->
            <!--                                                    王蓦瑶-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_fixedPhone">-->
            <!--                                                    89028586-->
            <!--                                                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"-->
            <!--                                                         data-v-ba633cb8="">-->
            <!--                                                        <path fill="currentColor"-->
            <!--                                                              d="M128 320v576h576V320H128zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zM960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32zM256 672h320v64H256v-64zm0-192h320v64H256v-64z"></path>-->
            <!--                                                    </svg>-->
            <!--                                                </div>-->
            <!--                                                <div class="header_ticr_list_mobile">-->
            <!--                                                    17835523140-->
            <!--                                                </div>-->
            <!--                                            </div>-->

            <!--                                        </div>-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                            </div>-->
            <!--                        </div>-->
            <!--                    </template>-->
            <!--                </el-dropdown>-->
            <!--            </div>-->
            <!--            <div class="headerLine">-->

            <!--            </div>-->


            <div class="headerSelect">
                <img src="../../assets/images/tx.png" alt="">
                <el-dropdown>
                    <span class="el-dropdown-link">
                      {{userName.roleName}} - {{userName.name}}
                      <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-ba633cb8=""><path
                          fill="currentColor"
                          d="M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z"></path></svg>
                    </span>
                    <template #dropdown>
<!--                        <div class="headerSelect_changePassword" @click="signOut">-->
<!--                            <i class="icon-lock_fill"></i>-->
<!--                            <span>-->
<!--                               修改密码-->
<!--                            </span>-->
<!--                        </div>-->
                        <div class="headerSelect_changePassword" @click="modifyRole">
                            <el-icon><UserFilled /></el-icon>
                            <!--<i class="icon-lock_fill"></i>-->
                            <span>
                               修改角色
                            </span>
                        </div>
                    </template>
                </el-dropdown>
            </div>
            <div class="headerLine">

            </div>
            <div>
                <i class="icon-signOut" @click="logout"></i>
            </div>
        </div>
    </div>
    <div class="modal" :style="{display:passwordModal?'block':'none'}">
        <div class="modal_content changePassword">
            <div class="modal_title">
                <p>修改密码</p>
                <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-ba633cb8=""
                     @click="passwordModalDisplay">
                    <path fill="currentColor"
                          d="M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm0 393.664L407.936 353.6a38.4 38.4 0 1 0-54.336 54.336L457.664 512 353.6 616.064a38.4 38.4 0 1 0 54.336 54.336L512 566.336 616.064 670.4a38.4 38.4 0 1 0 54.336-54.336L566.336 512 670.4 407.936a38.4 38.4 0 1 0-54.336-54.336L512 457.664z"></path>
                </svg>
            </div>
            <div class="modal_main">
                <div class="modal_formItem fontWeightBold">
                    <label class="">账号名称</label>
                    <span class="inputValueSpan">分中心</span>
                </div>
                <div class="modal_formItem fontWeightBold">
                    <label class="">密码</label>
                    <span class="inputValueSpan">********</span>
                </div>
                <div class="modal_line"></div>
                <el-form
                    :model="ruleForm"
                    :rules="rules"
                    label-position="left"
                    ref="ruleFormRef"
                >
                    <el-form-item label="当前密码" prop="oldPassword">
                        <el-input v-model="ruleForm.oldPassword"/>
                    </el-form-item>
                    <el-form-item label="新密码" prop="newPassword">
                        <el-input v-model="ruleForm.newPassword"/>
                    </el-form-item>
                    <el-form-item label="确认新密码" prop="newPassword1">
                        <el-input v-model="ruleForm.newPassword1"/>
                    </el-form-item>
                    <!--<el-form-item>-->
                    <div class="modal_footer">
                        <div class="modal_footer_btn" @click="passwordModalDisplay">
                            取消
                        </div>
                        <div class="modal_footer_btn confirmBtn" @click="submitForm(ruleFormRef)">
                            确认
                        </div>
                    </div>
                    <!--<el-button type="primary" @click="submitForm()"-->
                    <!--&gt;Create-->
                    <!--</el-button-->
                    <!--&gt;-->
                    <!--<el-button>Reset</el-button>-->
                    <!--</el-form-item>-->
                </el-form>

            </div>
        </div>
    </div>
    <div class="modal modifyRole" v-if="modifyRoleModalShow">
        <div class="modal_content changePassword">
            <div class="modal_title">
                <p>修改角色</p>
                <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-ba633cb8=""
                     @click="modifyRoleModalShow = false">
                    <path fill="currentColor"
                          d="M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm0 393.664L407.936 353.6a38.4 38.4 0 1 0-54.336 54.336L457.664 512 353.6 616.064a38.4 38.4 0 1 0 54.336 54.336L512 566.336 616.064 670.4a38.4 38.4 0 1 0 54.336-54.336L566.336 512 670.4 407.936a38.4 38.4 0 1 0-54.336-54.336L512 457.664z"></path>
                </svg>
            </div>
            <div class="modal_main">
                <div class="modifyRole_select">
                    <el-select v-model="getUserRoleValue" placeholder="请选择">
                        <el-option
                            v-for="item in getUserRoleList"
                            :key="item.roleKey"
                            :label="item.roleName"
                            :value="item.roleKey"
                        >
                        </el-option>
                    </el-select>
                </div>

                <div class="modal_footer">
                    <div class="modal_footer_btn" @click="modifyRoleModalShow = false">
                        取消
                    </div>
                    <div class="modal_footer_btn confirmBtn" @click="modifyRolesubmitForm">
                        确认
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {reactive, onMounted, ref, getCurrentInstance, computed} from 'vue'
    import {useStore} from 'vuex'
    import {useRouter} from 'vue-router';

    export default {
        name: "header",
        emits: ['jumpRouter'],
        setup(props, context) {
            const store = useStore();
            const router = useRouter();
            const {proxy} = getCurrentInstance();
            //头部tab切换 start
            const editableTabs = computed(() => store.state.leftTreeToHeaderTab.slice(1));
            const editableTabsValue = computed(() => {
                return store.state.headerActiveTab;
            })
            const changeTab = (param) => {
                if (param.props.label) {
                    store.state.headerActiveTab = param.props.label;
                } else {
                    store.state.headerActiveTab = "首页";
                }
                let jumpRouterObj = null;
                for (var i = 0; i < store.state.leftTreeToHeaderTab.length; i++) {
                    if (store.state.leftTreeToHeaderTab[i].label == store.state.headerActiveTab) {
                        jumpRouterObj = store.state.leftTreeToHeaderTab[i];
                        context.emit('jumpRouter', jumpRouterObj)
                        return
                    }
                }
            };
            const changeTabSelect = (param) => {
                store.state.headerActiveTab = param;
            }
            const removeTab = (param) => {
                store.commit("deletLeftTreeToHeaderTab", param);
                if (store.state.headerActiveTab == param) {
                    store.state.headerActiveTab = store.state.leftTreeToHeaderTab[store.state.leftTreeToHeaderTab.length - 1].label;
                }
            };
            //头部tab切换 end
            //用户信息请求
            let userName = ref({
                name: "",
                roleName: ""
            });
            const authInfo = () => {
                proxy.$axios.get("/jgfast/sys/user/userInfo").then((res) => {
                    if (res.code == "50000") {
                        router.push({
                            path: "/",
                        })
                    } else {
                        userName.value = res.user;
                        if (res.roles[0] == "WGSJ_ZX") {
                            store.state.addMapSignTree = true;
                        } else {
                            store.state.addMapSignTree = false;
                        }
                        if (res.roles[0] == "WGSJ_KSLD") {
                            store.state.inputBtnShow = false;
                        } else {
                            store.state.inputBtnShow = true;
                        }
                        if (res.roles[0] == "WGSJ_WGZ") {
                            store.state.gdlxSelectedGeneralEvents = true;
                        } else {
                            store.state.gdlxSelectedGeneralEvents = false;
                        }
                    }
                });
            }
            //修改密码 start
            const passwordModal = ref(false);
            const ruleFormRef = ref()
            const passwordModalDisplay = () => {
                passwordModal.value = !passwordModal.value;
            }
            const ruleForm = reactive({
                oldPassword: "",
                newPassword: "",
                newPassword1: ""
            })
            const newPasswordValidate = (rule, value, callback) => {
                var regp = /^(?=.*[a-zA-Z]+)(?=.*[0-9]+)[a-zA-Z0-9]+$/;
                if (!value) {
                    callback(new Error("请输入新密码"))
                } else if (value.length < 6 || value.length > 16 || !regp.test(value)) {
                    callback(new Error("密码长度6~16位，必须含有数字&字母"));
                } else {
                    callback()
                }
            }
            const validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入确认新密码'))
                } else if (value !== ruleForm.newPassword) {
                    callback(new Error("两次输入的新密码不一致"))
                } else {
                    callback()
                }
            }
            const rules = ref({
                oldPassword: [
                    {required: true, message: "请输入当前密码", trigger: 'blur'},
                ],
                newPassword: [
                    // {required: true, message: '请输入新密码', trigger: 'blur'},
                    // {min: 3, max: 5, message: 'Length should be 3 to 5', trigger: 'blur'},
                    {required: true, validator: newPasswordValidate, trigger: 'blur'},
                ],
                newPassword1: [
                    // {required: true, message: '请再次输入新密码', trigger: 'blur'},
                    // {min: 3, max: 5, message: 'Length should be 3 to 5', trigger: 'blur'},
                    {required: true, validator: validatePass2, trigger: 'blur'},
                ]
            })
            const formdataify = (params) => {
                const formData = new FormData();
                Object.keys(params).forEach(key => {
                    if (typeof params[key] == "string") {
                        formData.append(key, params[key]);
                    } else {
                        formData.append(key, JSON.stringify(params[key]));
                    }
                });
                return formData;
            };
            const submitForm = (param) => {
                if (!param) return
                param.validate((valid, fields) => {
                    if (valid) {
                        proxy.$axios.post("/jgfast/sys/user/updatePass", formdataify({
                            oldPassword: ruleForm.oldPassword,
                            newPassword: ruleForm.newPassword
                        })).then((res) => {
                            passwordModal.value = false;
                        });
                    } else {
                        console.log('error submit!', fields)
                    }
                })
            }
            const logout = () => {
                proxy.$axios.get("/jgfast/logout/other").then((res) => {
                    localStorage.clear();
                    router.push({
                        path: "/",
                    })
                    store.state.leftTreeToHeaderTab = [{
                        name: "Home",//组件的名称
                        label: "首页",//组件在头部显示的tab名字
                        linkTo: "/Home",//目前无作用
                        query: null,//传递给组件的值
                    }]
                });
            }
            let getUserRoleList = ref([])
            let getUserRoleValue = ref()
            const getUserRole = ()=>{
                proxy.$axios.get("/jgfast/wgsj/getUserRoleList").then((res) => {
                    getUserRoleList.value = res.data;
                });
            }
            const modifyRolesubmitForm=()=>{
                proxy.$axios.post("/jgfast/wgsj/setUserRole",{
                    roleKey:getUserRoleValue.value
                }).then((res) => {
                    modifyRoleModalShow.value = false;
                    router.go(0)
                });
            }
            let modifyRoleModalShow= ref(false)
            const modifyRole = ()=>{
                modifyRoleModalShow.value = true;
            }
            onMounted(() => {
                authInfo();
                getUserRole()
            })
            //修改密码 end
            return {
                editableTabs,
                editableTabsValue,
                changeTab,
                removeTab,
                ruleForm,
                rules,
                passwordModal,
                ruleFormRef,
                passwordModalDisplay,
                submitForm,
                changeTabSelect,
                userName,
                logout,
                modifyRole,
                modifyRoleModalShow,
                getUserRoleList,
                getUserRoleValue,
                modifyRolesubmitForm
            }
        }
    }
</script>

<style lang="less">

</style>
